import React from 'react';

import ChartActivity from './chart_activity';
import Chart12Month from './chart_12month';
import ChartTopics from './chart_topics';
import ChartAreas from './chart_areas';
import { FiltersRecords } from '../moduleComponents/FiltersRecords';
import SpinnerLoad from '../moduleComponents/SpinnerLoad';

// Summary — Stats sub-tab (L1). Content only; NavbarMiddle (Stats/Areas) and its
// state live in health_main.js, mirroring finance_main.js (NavbarMiddle at the
// parent level, deciding which L1 component to render alongside NavbarTop/Bottom).
const TabHealthSummaryStats = ({
  unfilteredRecords,
  isLoading = false,
  filterType,
  setFilterType,
  filterArea,
  setFilterArea,
  filterDescription,
  setFilterDescription,
  types,
  areas,
  handleClearFilters,
}) => {
  if (isLoading) {
    return (
      <div className="flex justify-center py-16">
        <SpinnerLoad />
      </div>
    );
  }

  // filtered records
  const records = unfilteredRecords
    .filter(item =>
      (filterType ? item.type === filterType : true) &&
      (filterArea ? item.area === filterArea : true) &&
      item.description.toLowerCase().includes(filterDescription.toLowerCase())
    );

  // Data for Last 12 Months (BarChart Vertical)
  const formatMonthYear = (date) =>
    new Intl.DateTimeFormat('en', { month: 'short', year: '2-digit' }).format(date);

  const months = Array.from({ length: 12 }, (_, i) => {
    const d = new Date();
    d.setMonth(d.getMonth() - (11 - i));
    return formatMonthYear(d);
  });

  const monthlyData = months.map((month) => ({
    month,
    records: records.filter((r) => formatMonthYear(new Date(r.date)) === month).length,
  }));

  // Data for Topics (TreeMap)
  const topicMap = records.reduce((acc, r) => {
    acc[r.type] = (acc[r.type] || 0) + 1;
    return acc;
  }, {});
  const topicsData = Object.entries(topicMap).map(([name, size]) => ({ name, size }));

  // Data for Areas (BarChart Horizontal)
  const areaMap = records.reduce((acc, r) => {
    acc[r.area] = (acc[r.area] || 0) + 1;
    return acc;
  }, {});

  const areasData = Object.entries(areaMap).map(([area, count]) => ({ area, count }));

  return (
    <div className="p-0">
      {/* Records Filters */}
      <FiltersRecords
        filterDescription={filterDescription}
        setFilterDescription={setFilterDescription}
        filterArea={filterArea}
        setFilterArea={setFilterArea}
        filterType={filterType}
        setFilterType={setFilterType}
        areas={areas}
        types={types}
        handleClearFilters={handleClearFilters}
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
        {/* Card Activity Summary*/}
        <ChartActivity records={records} />

        {/* Card 12 Month - Bar Chart */}
        <Chart12Month data={monthlyData} />

        {/* Card Topics - Treemap */}
        <ChartTopics data={topicsData} />

        {/* Card Areas - Bar Chart Horizontal */}
        <ChartAreas data={areasData} />
      </div>
    </div>
  );
};

export default TabHealthSummaryStats;
